// extracted by mini-css-extract-plugin
module.exports = {"sign-button":"styles__sign-button___1H7sQ","link":"styles__link___3A-tu","more-details":"styles__more-details___33tnT"};